export default {
  getApplicationName() {
    return process.env.APP_NAME;
  },
  getReadableVersion() {
    return `${process.env.VERSION}.${process.env.BUILD_NUMBER}`;
  }
};
